import { CommonModule } from "@angular/common";
import { Component, model, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IObjectAddress } from "@nova/common-interfaces";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DialogModule } from "primeng/dialog";
import { InputText } from "primeng/inputtext";
import * as SmartyStreetsSDK from "smartystreets-javascript-sdk";
import { IGeographicalInformation } from "../../pages/dashboard/order-dashboard.component";

@Component({
  selector: "app-order-address",
  imports: [
    CommonModule,
    AutoCompleteModule,
    FormsModule,
    InputText,
    ReactiveFormsModule,
    DialogModule,
  ],
  templateUrl: "./address.component.html",
  styleUrl: "./address.component.scss",
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class OrderAddressComponent implements OnInit {
  address = model.required<IObjectAddress>();
  geographical_information = model<IGeographicalInformation | undefined>();

  visible: boolean = false;
  addressOptions = <any>[];

  async addressSelected(event: any) {
    console.log("Setting form", event.value);
    this.address.set({
      line1: event.value.streetLine,
      town: event.value.city,
      state: event.value.state,
      postal_code: event.value.zipcode,
    } as IObjectAddress);

    const SmartyStreetsCore = SmartyStreetsSDK.core;
    const websiteKey = "112622355404515731"; // Your Website Key
    const Lookup = SmartyStreetsSDK.usStreet.Lookup;
    const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials);
    const client = clientBuilder.buildUsStreetApiClient();
    const lookup = new Lookup(
      event.value.streetLine,
      undefined,
      undefined,
      event.value.city,
      event.value.state,
      event.value.zipcode
    );
    const result = await client.send(lookup);
    console.log("SMARTY STREET", result.lookups[0].result[0].metadata);
    const results = result.lookups as any[];
    if (results.length > 0) {
      this.geographical_information.set({
        longitude: results[0].result[0].metadata.latitude,
        latitude: results[0].result[0].metadata.longitude,
      } as IGeographicalInformation);
    }

    console.log("Updated form", this.address());
  }

  showDialog() {
//    this.visible = true;
  }
  constructor(public fb: FormBuilder, private router: Router) {}

  async searchAddress(event: any) {
    console.log(event);
    const SmartyStreetsCore = SmartyStreetsSDK.core;
    const websiteKey = "112622355404515731"; // Your Website Key
    const Lookup = SmartyStreetsSDK.usAutocompletePro.Lookup;
    const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials);
    const client = clientBuilder.buildUsAutocompleteProClient();
    const lookup = new Lookup(event.query);
    lookup.maxResults = 10;
    const result = await client.send(lookup);
    console.log("Smarty", result);
    this.addressOptions = result.result as any[];
  }

  ngOnInit() {}
  handleRoute() {
    this.router.navigate(["/orders/internet-plan"]);
    this.visible = false;
  }
}
